import TileMenu from './tileMenu'
import { selectTile, selectSample, changeColors, selectColor } from '../../actions/index'
import { connect } from 'react-redux'

const mapStateToProps = ( state, props ) => ({
	tiles : state.tiles,
	selectedTile: state.selectedTile,
	selectedSample: state.selectedSample
})

const mapDispatchToProps = ( dispatch, props ) => ({
	onSelectTile : ( id, colors ) => { dispatch( selectTile( id ), dispatch(changeColors(colors), dispatch(selectSample(0))) );}
})

const VisibleTileMenu = connect( mapStateToProps, mapDispatchToProps ) (TileMenu);

export default VisibleTileMenu;



// WEBPACK FOOTER //
// ./src/components/mosaic/visibleTileMenu.jsx